import { FormationDetailProps } from '@/types/formation';

export const cseFormation: FormationDetailProps = {
  id: '27',
  title: 'Formation CSE - Comité Social et Économique',
  description: 'Formation complète pour les membres du Comité Social et Économique (CSE) pour exercer efficacement leur mission de représentation du personnel et de prévention des risques professionnels.',
  duration: '3 à 5 jours',
  category: 'Formation CSE',
  imageSrc: '/images/home/sdpsilogo.png',
  slug: 'sdps',
  reference: 'F-CSE',
  price: 'Sur devis – nous contacter',
  targetAudience: 'Membres du CSE (titulaires et suppléants), représentants du personnel, élus du personnel',
  prerequisites: 'Aucun prérequis particulier',
  objectives: [
    'Connaître le rôle et les missions du CSE',
    'Maîtriser le cadre juridique et réglementaire',
    'Comprendre les enjeux de la santé et sécurité au travail',
    'Savoir organiser et animer les réunions du CSE',
    'Maîtriser les techniques de communication et de négociation'
  ],
  program: [
    {
      title: 'Institutions représentatives du personnel',
      items: [
        'Historique et évolution des IRP',
        'Composition et organisation du CSE',
        'Rôle et missions des élus',
        'Moyens du CSE (heures de délégation, crédit d\'heures, budget)'
      ]
    },
    {
      title: 'Santé et sécurité au travail',
      items: [
        'Rôle du CSE en matière de santé et sécurité',
        'Document unique d\'évaluation des risques (DUER)',
        'Droit d\'alerte et droit de retrait',
        'Accidents du travail et maladies professionnelles'
      ]
    },
    {
      title: 'Fonctionnement du CSE',
      items: [
        'Organisation des réunions',
        'Procédures de vote et prise de décision',
        'Rédaction des comptes-rendus',
        'Gestion du budget et des activités sociales et culturelles'
      ]
    }
  ],
  pedagogicalMethods: [
    'Apports théoriques et juridiques',
    'Études de cas pratiques',
    'Mises en situation',
    'Échanges d\'expériences',
    'Support de formation remis aux participants'
  ],
  evaluationMethods: [
    'Évaluation des connaissances acquises',
    'Mises en situation pratiques',
    'Questionnaire de satisfaction'
  ],
  certification: 'Attestation de formation CSE',
  registrationProcess: [
    'Inscription possible jusqu\'à 15 jours avant le début de la formation',
    'Groupe de 4 à 12 participants maximum'
  ],
  accessibilityCriteria: 'Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.',
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
